export class TypeIntervention {
  id: string;
  libelle: string;

  constructor(id: string, libelle: string) {
    this.id = id;
    this.libelle = libelle;
  }
}